export default __webpack_public_path__ + "static/media/denis.02c0bb3c.jpg";